contentsMenu();
videoSlider();
videoModal();
faqForm();
stickyContents();

// toggle active class for contents menu
function contentsMenu() {
    let container = document.getElementById("contents");
    if (container) {
        let btns = container.getElementsByClassName("link");
        for (let i = 0; i < btns.length; i++) {
            btns[i].addEventListener("click", function () {
                let current = document.getElementsByClassName("active");
                if (current.length > 0) {
                    current[0].className = current[0].className.replace(" active", "");
                }
                this.className += " active";
            });
        }
    }
}

// contents menu
function stickyContents() {
    const header = document.querySelector("#contents");
    const scrollUp = "sticky";
    const scrollDown = "sticky";
    let lastScroll = 0;

    window.addEventListener("scroll", () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll <= 70) {
            header.classList.remove(scrollUp);
            header.classList.remove(scrollDown);
            return;
        }

        if (currentScroll > lastScroll && ! header.classList.contains(scrollDown)) { // down
            header.classList.remove(scrollUp);
            header.classList.add(scrollDown);
        } else if (currentScroll < lastScroll && header.classList.contains(scrollDown)) { // up
            header.classList.remove(scrollDown);
            header.classList.add(scrollUp);
        }
        lastScroll = currentScroll;
    });
}

//sliders
function videoSlider() {
    $('#video-slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button class="prev d-flex justify-content-center align-items-center"><img src="/wp-content/themes/sankara/dist/img/chevron-left.svg" width="1" height="1" alt="prev"></button>',
        nextArrow: '<button class="next d-flex justify-content-center align-items-center"><img src="/wp-content/themes/sankara/dist/img/chevron-right.svg" width="1" height="1" alt="next"></button>',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToScroll: 1,
                    infinite: false,
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

function getYoutubeId(url) {
    let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    let match = url.match(regExp);
    return(match && match[7].length == 11) ? match[7] : false;
}


// FAQ
function videoModal() {
    const videos = document.querySelectorAll('.video-single a');
    for (const video of videos) {
        video.addEventListener('click', function openVideoModal(e) {
            e.preventDefault();
            const modal = document.querySelector("#video-modal"),
                  modalContent = modal.querySelector('.modal-content');
            let type = video.getAttribute('data-type'),
                url = video.getAttribute('data-url'),
                title = video.getAttribute('title');
            if (type == 'youtube') {
                let yt_id = getYoutubeId(url);
                let content = "<h2>" + title + "</h2><iframe width='560' height='315' src='https://www.youtube.com/embed/" + yt_id + "?autoplay=1' title='" + title + "' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>"
                modalContent.innerHTML = content;
            } else {
                let content = "<h2>" + title + "</h2><video width='560' height='315' src='" + url + "' autoplay controls></video>"
                modalContent.innerHTML = content;
            } 
            modal.style.display="block";
        });
    }
}

document.querySelector('.btn-close').addEventListener('click', function() {
    const modal = document.querySelector("#video-modal"),
          modalContent = modal.querySelector('.modal-content');
          modalContent.innerHTML = null;
});

function faqForm() {
    var form = document.getElementById("faq-form");
    function handleForm(event) { event.preventDefault(); } 
    form.addEventListener('submit', handleForm);

    //search in accordion
    let search = document.getElementById( 'faq-search' ),
        accordions = document.querySelectorAll( '.accordion-item' ),
        searchText = search.value.toLowerCase();

    // Apply search
    search.addEventListener( 'input', function() {
        searchText = search.value.toLowerCase();
        Array.prototype.forEach.call( accordions, function( accordion ) {
            if ( accordion.innerText.toLowerCase().indexOf( searchText ) >= 0 ) {
                accordion.style.display = 'block';
            }
            else {
                accordion.style.display = 'none';
            }
        } );
    } );

    Array.prototype.forEach.call( accordions, function( accordion ) {
        if ( accordion.innerText.toLowerCase().indexOf( searchText ) >= 0 ) {
            // If the index of searchText is -1 then it is not in the accordion.
            // Otherwise it is, so we display the accordion
            accordion.style.display = 'block';
        }
        else {
            // We hide the accordion if searchText is not found
            accordion.style.display = 'none';
        }
    } );
}

